import React, { useState, useEffect } from "react";

// Components
import Main from "./CreditNote/Main";
import Form from "./CreditNote/Form";
import moment from "moment";

import {
  getData,
  getDocStatusColour,
  getAlert,
  getMaxDocNo,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

const CreditNote = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [cachedStatusColours, setCachedStatusColours] = useState(null); // Cache for status colors
  const [maxDocNo, setMaxDocNo] = useState();
  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem("creditNoteStartDate");
    // เก็บเป็น BE (พ.ศ.)
    return (
      storedStartDate ||
      moment().startOf("month").add(543, "year").format("YYYY-MM-DD")
    );
  });

  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem("creditNoteEndDate");
    return (
      storedEndDate ||
      moment().endOf("month").add(543, "year").format("YYYY-MM-DD")
    );
  });

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(true); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const convertBEtoAD = (dateStr) => {
    return moment(dateStr, "YYYY-MM-DD")
      .subtract(543, "year")
      .format("YYYY-MM-DD");
  };


  const fetchRealtime = async (
    updateMaxDocNo = true,
    allDates = false,
    overrideStartDate = null,
    overrideEndDate = null
  ) => {
    try {
      // ใช้วันที่จากพารามิเตอร์ถ้ามี มิฉะนั้นใช้ state ปัจจุบัน
      const beStart = overrideStartDate || startDate;
      const beEnd = overrideEndDate || endDate;

      // เก็บ พ.ศ. ลง localStorage เพื่อกลับมาแสดงผลต่อได้
      localStorage.setItem("creditNoteStartDate", beStart);
      localStorage.setItem("creditNoteEndDate", beEnd);

      const startAD = convertBEtoAD(beStart);
      const endAD = convertBEtoAD(beEnd);

      // Optimized: ใช้ index-friendly query
      const whereClause = allDates
        ? "1=1 ORDER BY Doc_Date DESC, Doc_No DESC"
        : ` Doc_Date >= '${startAD}' AND Doc_Date <= '${endAD}' ORDER BY Doc_Date DESC, Doc_No DESC`;



      // Parallel execution: โหลดข้อมูลพร้อมกัน
      const promises = [getData("API_0901_CR_H", whereClause)];

      if (!cachedStatusColours) {
        promises.push(getDocStatusColour("CR", "Doc_Status"));
      }

      if (updateMaxDocNo) {
        promises.push(
          getData(
            "API_0901_CR_H",
            "1=1 ORDER BY Doc_ID DESC OFFSET 0 ROWS FETCH NEXT 1 ROWS ONLY"
          )
        );
      }

      const results = await Promise.all(promises);
      let masterList, docStatusColour, findMaxDocNo;

      if (!cachedStatusColours) {
        [masterList, docStatusColour, findMaxDocNo] = results;
      } else {
        docStatusColour = cachedStatusColours;
        if (updateMaxDocNo) {
          [masterList, findMaxDocNo] = results;
        } else {
          [masterList] = results;
        }
      }

      if (masterList?.length > 0) {
        setDataMasterList(masterList);
      }

      if (docStatusColour?.length > 0) {
        setStatusColours(docStatusColour);
        if (!cachedStatusColours) {
          setCachedStatusColours(docStatusColour);
        }
      }

      if (updateMaxDocNo && findMaxDocNo) {
        const maxDoc = getMaxDocNo(findMaxDocNo, "CR");
        setMaxDocNo(maxDoc);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
    // เมื่อสร้างใหม่ ให้อัพเดท maxDocNo
    fetchRealtime(true);
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    setMode("U");
    // ไม่อัพเดท maxDocNo เพราะใช้ docNo ที่เลือก
    fetchRealtime(false);
  };

  return (
    <div className="CreditNote">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  name={"ใบลดหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  getReport={getReport}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  startDate={startDate}
                  endDate={endDate}
                  fetchRealtime={fetchRealtime}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบลดหนี้"}
                  maxDocNo={maxDocNo}
                  getReport={getReport}
                  setMaxDocNo={setMaxDocNo}
                  setMode={setMode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditNote;
